export default "__VITE_ASSET__BgrEMMVh__"